// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__9hb2e","content":"styles_content__2D4mx","checkbox":"styles_checkbox__3tI_7","checkboxLabel":"styles_checkboxLabel__20hQr"};